import styled from 'styled-components';
import { Typography } from '@material-ui/core';

const TabItemTitle = styled(Typography)`
  font-weight: bold;
  line-height: 18px;
  color: inherit;
`;

const TabItemQuantity = styled(Typography)`
  font-weight: 500;
  font-size: 31px;
  line-height: 24px;
  margin-top: 12px;
`;

const BookingsTotalNumbersWrapper = styled.div`
  margin-top: 18px;
  display: flex;
  gap: 20px;
`;

const BookingsItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const BookingsItemCaption = styled.div`
  padding-top: 6px;
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;

  letter-spacing: 0.035em;
  text-transform: uppercase;
`;

export {
  TabItemTitle,
  TabItemQuantity,
  BookingsTotalNumbersWrapper,
  BookingsItem,
  BookingsItemCaption
};
